import Breakpoint from 'components/Layout/Breakpoint';
import { FunctionComponent, ReactNode } from 'react';

interface ExperiencePriceWidgetDesktopProps {
  children: ReactNode;
}

const ExperiencePriceWidgetDesktop: FunctionComponent<
  ExperiencePriceWidgetDesktopProps
> = ({ children }) => {
  return (
    <Breakpoint type="min" bp="MD">
      <section className="price-widget relative w-[400px]">
        <div className="sticky top-2 z-10 w-full min-w-[340px] rounded-md border p-4 shadow-md">
          {children}
        </div>
      </section>
    </Breakpoint>
  );
};

export default ExperiencePriceWidgetDesktop;
